import { FailureType, FailureMode } from "./failureTypes";

export const failureTypeToModeMap: Record<FailureType, FailureMode[]> = {
  [FailureType.ACESSÓRIOS_E_OUTROS]: [FailureMode.ACESSÓRIOS_E_OUTROS],
  [FailureType.ALINHAMENTO_DE_CHASSIDIREÇÃO]: [FailureMode.CHASSI],
  [FailureType.AMORTECEDORES_SUSPENSÃO]: [
    FailureMode.SISTEMA_DE_SUSPENSÃO_DIANTEIRA,
  ],
  [FailureType.ATRITO_DO_CHICOTE_ELÉTRICO_COM_O_CORRUGADO]: [
    FailureMode.SISTEMA_ELÉTRICO,
  ],
  [FailureType.ATUALIZAÇÃO_DE_SOFTWARE]: [FailureMode.SISTEMA_ELÉTRICO],
  [FailureType.AÇÃO_DE_CAMPO]: [FailureMode.AÇÃO_DE_CAMPO],
  [FailureType.BARRA_DE_DIREÇÃO]: [FailureMode.SISTEMA_DE_DIREÇÃO],
  [FailureType.BATERIA]: [FailureMode.SISTEMA_ELÉTRICO],
  [FailureType.BOMBA_DÁGUA]: [FailureMode.MOTOR],
  [FailureType.BOMBA_DE_ALTA_PRESSÃO_DE_COMBUSTIVEL]: [
    FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO,
  ],
  [FailureType.BOMBA_DE_ÓLEO]: [FailureMode.MOTOR],
  [FailureType.BOMBA_DIREÇÃO_HIDRÁULICA]: [FailureMode.MOTOR],
  [FailureType.CABEÇOTE]: [FailureMode.MOTOR],
  [FailureType.CAIXA_DE_DIREÇÃO]: [FailureMode.SISTEMA_DE_DIREÇÃO],
  [FailureType.CAIXA_DE_MARCHAS_ENTRA_EM_NEUTRO]: [
    FailureMode.CAIXA_DE_MUDANÇA,
  ],
  [FailureType.CAIXA_DE_MUDANÇA]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.CAMISA_DO_BLOCO]: [FailureMode.MOTOR],
  [FailureType.CAPTAÇÃO_DE_AR_ENTRADA_DE_ABRASIVO]: [FailureMode.MOTOR],
  [FailureType.CARDAN]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.CARROCERIA]: [FailureMode.CARROCERIA],
  [FailureType.CATALISADOR_OBSTRUÍDO]: [FailureMode.PÓSTRATAMENTO],
  [FailureType.CATRACA_DE_FREIO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.CHASSI]: [FailureMode.CHASSI],
  [FailureType.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO]: [
    FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO,
  ],
  [FailureType.COMPRESSOR_DE_AR]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.CONSUMO_DE_OLEO_LUBRIFICANTE_EM_EXCESSO]: [FailureMode.MOTOR],
  [FailureType.CUICA_DE_FREIO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.CÂMARA_DE_FREIO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.DESGASTE_DE_ANEIS_SINCRONIZADORES]: [
    FailureMode.CAIXA_DE_MUDANÇA,
  ],
  [FailureType.DESGASTE_DE_LUVA_DE_ENGATE_GP_E_GV]: [
    FailureMode.CAIXA_DE_MUDANÇA,
  ],
  [FailureType.DESGASTE_DO_GARFO_DE_ENGATE]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.EIXO_S_CAME]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.EIXO_DE_TRAÇÃO]: [FailureMode.EIXO_TRASEIRO],
  [FailureType.EIXO_E_CAIXA_DE_DIREÇÃO]: [FailureMode.EIXO_E_CAIXA_DE_DIREÇÃO],
  [FailureType.EIXO_TRASEIRO]: [FailureMode.EIXO_TRASEIRO],
  [FailureType.EM_DIAGNOSE_00_ACESSÓRIOS_E_OUTROS]: [
    FailureMode.ACESSÓRIOS_E_OUTROS,
  ],
  [FailureType.EM_DIAGNOSE_10_MOTOR]: [FailureMode.MOTOR],
  [FailureType.EM_DIAGNOSE_100_REVISÃO]: [FailureMode.REVISÃO],
  [FailureType.EM_DIAGNOSE_110_SOFTWARE]: [FailureMode.SOFTWARE],
  [FailureType.EM_DIAGNOSE_120_SINISTRO]: [FailureMode.SINISTRO],
  [FailureType.EM_DIAGNOSE_130_AÇÃO_DE_CAMPO]: [FailureMode.AÇÃO_DE_CAMPO],
  [FailureType.EM_DIAGNOSE_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO]:
    [FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO],
  [FailureType.EM_DIAGNOSE_30_CAIXA_DE_MUDANÇA]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.EM_DIAGNOSE_40_EIXO_E_CAIXA_DE_DIREÇÃO]: [
    FailureMode.EIXO_E_CAIXA_DE_DIREÇÃO,
  ],
  [FailureType.EM_DIAGNOSE_50_EIXO_TRASEIRO]: [FailureMode.EIXO_TRASEIRO],
  [FailureType.EM_DIAGNOSE_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.EM_DIAGNOSE_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA]:
    [FailureMode.SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA],
  [FailureType.EM_DIAGNOSE_80_CARROCERIA]: [FailureMode.CARROCERIA],
  [FailureType.EM_DIAGNOSE_90_SISTEMA_ELÉTRICO]: [FailureMode.SISTEMA_ELÉTRICO],
  [FailureType.EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO]: [
    FailureMode.EMBREAGEM_EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO,
  ],
  [FailureType.EMBREAGEM_VISCOSA_HÉLICE]: [
    FailureMode.EMBREAGEM_EMBREAGEM_INCLUINDO_SISTEMA_DE_ACIONAMENTO,
  ],
  [FailureType.EMBUCHAMENTO_MANGA_EIXO]: [
    FailureMode.SISTEMA_DE_SUSPENSÃO_DIANTEIRA,
  ],
  [FailureType.ENGATE_DE_MARCHAS]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.FALTA_DE_LUBRIFICAÇÃO]: [FailureMode.MOTOR],
  [FailureType.FREIO_MOTOR]: [FailureMode.MOTOR],
  [FailureType.GELADEIRA]: [FailureMode.CARROCERIA],
  [FailureType.INJETORES_DE_COMBUSTIVEL]: [FailureMode.MOTOR],
  [FailureType.LONA_DE_FREIO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.MANGUEIRAS_TUBULAÇÕES]: [FailureMode.MOTOR],
  [FailureType.MODIFICAÇÃOATUALIZAÇÃO_DE_PRODUTO]: [FailureMode.CHASSI],
  [FailureType.MOLA_PNEUMÁTICA]: [FailureMode.SISTEMA_DE_SUSPENSÃO_TRASEIRA],
  [FailureType.MOTOR]: [FailureMode.MOTOR],
  [FailureType.MÓDULO_TCU]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.OUTROS_10_MOTOR]: [FailureMode.MOTOR],
  [FailureType.OUTROS_100_REVISÃO]: [FailureMode.REVISÃO],
  [FailureType.OUTROS_110_SOFTWARE]: [FailureMode.SOFTWARE],
  [FailureType.OUTROS_120_SINISTRO]: [FailureMode.SINISTRO],
  [FailureType.OUTROS_130_AÇÃO_DE_CAMPO]: [FailureMode.AÇÃO_DE_CAMPO],
  [FailureType.OUTROS_20_COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO]:
    [FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO],
  [FailureType.OUTROS_30_CAIXA_DE_MUDANÇA]: [FailureMode.CAIXA_DE_MUDANÇA],
  [FailureType.OUTROS_40_EIXO_E_CAIXA_DE_DIREÇÃO]: [
    FailureMode.EIXO_E_CAIXA_DE_DIREÇÃO,
  ],
  [FailureType.OUTROS_50_EIXO_TRASEIRO]: [FailureMode.EIXO_TRASEIRO],
  [FailureType.OUTROS_60_SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.OUTROS_70_SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA]: [
    FailureMode.SISTEMA_DE_ALAVANCA_PEDALEIRA_E_CABOS_DE_MARCHA,
  ],
  [FailureType.OUTROS_80_CARROCERIA]: [FailureMode.CARROCERIA],
  [FailureType.OUTROS_90_SISTEMA_ELÉTRICO]: [FailureMode.SISTEMA_ELÉTRICO],
  [FailureType.OUTROS_ACESSÓRIOS_E_OUTROS]: [FailureMode.ACESSÓRIOS_E_OUTROS],
  [FailureType.PERDA_DE_POTÊNCIA]: [FailureMode.MOTOR],
  [FailureType.PINTURA_C_PROBLEMA_QUALIDADE]: [FailureMode.CARROCERIA],
  [FailureType.PRESSÃO_LÍQ_ARREFECIMENTO_DO_MOTOR]: [FailureMode.MOTOR],
  [FailureType.PÓS_TRATAMENTO]: [FailureMode.PÓSTRATAMENTO],
  [FailureType.QUEBRA_DA_ABRAÇADEIRA_TUBO_DE_ESCAPE_PÓS_TURBO]: [
    FailureMode.MOTOR,
  ],
  [FailureType.QUEBRA_DO_SUPORTE_DO_PARALAMA]: [FailureMode.CARROCERIA],
  [FailureType.RADIADOR]: [
    FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO,
  ],
  [FailureType.RASTREADOR]: [FailureMode.ACESSÓRIOS_E_OUTROS],
  [FailureType.REFORMA_ENTRE_SAFRA]: [FailureMode.SINISTRO],
  [FailureType.REPARO]: [FailureMode.SINISTRO],
  [FailureType.REPARO_DE_FUNILARIA_E_PINTURA]: [FailureMode.CARROCERIA],
  [FailureType.RETENTORCUBOROLAMENTO]: [FailureMode.EIXO_TRASEIRO],
  [FailureType.RETRABALHO_CHASSI]: [FailureMode.AÇÃO_DE_CAMPO],
  [FailureType.REVISÃO]: [FailureMode.REVISÃO],
  [FailureType.REVISÃO_ACESSÓRIOS_E_OUTROS]: [FailureMode.ACESSÓRIOS_E_OUTROS],
  [FailureType.REVISÃO_VEICULO_DEMONSTRAÇÃO]: [FailureMode.ACESSÓRIOS_E_OUTROS],
  [FailureType.ROLAMENTO_DE_RODA]: [FailureMode.ROLAMENTO_DE_RODA],
  [FailureType.ROTAÇÃO_DE_BRONZINACASQUILHO]: [FailureMode.MOTOR],
  [FailureType.SINISTRO]: [FailureMode.SINISTRO],
  [FailureType.SISTEMA_ABS]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.SISTEMA_DE_ADMISSÃO_DE_AR]: [FailureMode.MOTOR],
  [FailureType.SISTEMA_DE_ALIMENTAÇÂO_DE_COMBUSTIVEL]: [
    FailureMode.COMBUSTÍVEL_GÁS_DE_ESCAPE_E_ARREFECIMENTO_PÓS_TRATAMENTO,
  ],
  [FailureType.SISTEMA_DE_ELEVAÇÃO_DE_EIXO]: [
    FailureMode.SISTEMA_DE_SUSPENSÃO_TRASEIRA,
  ],
  [FailureType.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO]: [
    FailureMode.SISTEMA_DE_FREIO_E_CIRCUITO_PNEUMÁTICO,
  ],
  [FailureType.SISTEMA_ELÉTRICO]: [FailureMode.SISTEMA_ELÉTRICO],
  [FailureType.SISTEMAMANGUEIRAS_DE_ARREFECIMENTO]: [FailureMode.MOTOR],
  [FailureType.SOFTWARE]: [FailureMode.SOFTWARE],
  [FailureType.TIRANTE_V]: [FailureMode.SISTEMA_DE_SUSPENSÃO_TRASEIRA],
  [FailureType.TROCA_RELAÇÃO_DIFERENCIAL]: [FailureMode.EIXO_TRASEIRO],
  [FailureType.TUBO_DE_ADMISSÃO_DE_AR_COM_CORROSÃO]: [FailureMode.MOTOR],
  [FailureType.TUBOS_SISTEMA_DE_ESCAPAMENTO]: [FailureMode.MOTOR],
  [FailureType.TURBOCOMPRESSOR]: [FailureMode.MOTOR],
  [FailureType.VAZAMENTO_DE_LUBRIFICANTE_PELA_PTO]: [
    FailureMode.CAIXA_DE_MUDANÇA,
  ],
  [FailureType.VAZAMENTO_DE_ÓLEO_LUBRIFICANTE]: [FailureMode.MOTOR],
};
